import AdminRequest from './AdminRequest';
/**
 * Provides a set of operations around API: /nodehandlers.
 */
export default class NodehandlersClient extends AdminRequest {
	constructor() {
		super('/nodehandlers');
	}
	getSpec(type) {
		const handlerType = encodeURIComponent(type);
		return this._op('get', `${this.uri}/${handlerType}`, null);
	}
	getSpecs() {
		return this._op('get', `${this.uri}`, null);
	}
}
